
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fb5x", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $luv00 = parcelRequire("luv00");


var $6mKj3 = parcelRequire("6mKj3");


var $dA1Sn = parcelRequire("dA1Sn");





var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $e4o8D = parcelRequire("e4o8D");


var $jMyy4 = parcelRequire("jMyy4");





var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");




/**
 * @generated SignedSource<<8123d4d752ec36317e81af577d546915>>
 * @relayHash 81e92b7bef30c91df7d1d5fc36cdd372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72
const $6900e8f8fbd4b479$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "color"
    }, v4 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        }
                    ]
                },
                {
                    "condition": "isDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "format",
                                    "value": "USER_FRIENDLY"
                                }
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ],
                            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "81e92b7bef30c91df7d1d5fc36cdd372",
            "id": "8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72",
            "metadata": {},
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineWithContributorsComponentEditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$6900e8f8fbd4b479$var$node.hash = "cbad882df31b75e4699e60f1bcf2ae8b";
var $6900e8f8fbd4b479$export$2e2bcd8739ae039 = $6900e8f8fbd4b479$var$node;






var $T1bCI = parcelRequire("T1bCI");


var $gdv5Z = parcelRequire("gdv5Z");


var $laFNM = parcelRequire("laFNM");


var $63EIj = parcelRequire("63EIj");


var $jkVM2 = parcelRequire("jkVM2");


var $bJX6u = parcelRequire("bJX6u");


var $9wGTI = parcelRequire("9wGTI");


var $7om8k = parcelRequire("7om8k");


var $7QM6o = parcelRequire("7QM6o");





var $aXWIB = parcelRequire("aXWIB");


var $ecnYn = parcelRequire("ecnYn");


var $6f0Oj = parcelRequire("6f0Oj");


var $4FHTF = parcelRequire("4FHTF");


var $3FlVr = parcelRequire("3FlVr");


var $83sfO = parcelRequire("83sfO");





var $1NF8X = parcelRequire("1NF8X");





var $5UrgY = parcelRequire("5UrgY");

const $06f66a283e23582e$var$i18n = (0, $aXWIB.defineMessages)({
    addNew: {
        id: "live-pages-features.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "live-pages-features.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $06f66a283e23582e$var$dotStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-050, 4px)",
    width: "var(--ds-space-050, 4px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'radius.full',
    alignSelf: 'center',
    transition: 'opacity 300ms ease-in-out'
});
const $06f66a283e23582e$var$floatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'left',
    transition: 'left 600ms',
    marginBottom: 'space.025',
    height: '28px',
    marginTop: 'space.025'
});
const $06f66a283e23582e$export$37ba4ba009bc421f = ({ contentId: contentId, spaceId: spaceId, isDisabled: isDisabled = false, contentType: contentType, isCurrentUserContributor: isCurrentUserContributor = false, editorBylineContainerRef: editorBylineContainerRef })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Used when we want to allow the user to select reactions from the summary view popup
    const customIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
        testId: "emoji-add-icon",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    });
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const { isEligible: isEligibleReactionsFeedbackPageReturn } = (0, $5UrgY.useIsEligibleReactionsFeedbackPageReturn)({
        contentId: contentId,
        isContributor: Boolean(isCurrentUserContributor),
        skip: !(0, $9wGTI.fg)('cc-engagement-reaction-feedback-page-return-kill'),
        source: 'livePage'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f66a283e23582e$var$floatingContainerStyles,
        testId: "live-pages-reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType === 'blogpost' ? (0, $3FlVr.ReactionLocation).BLOGPOST : (0, $3FlVr.ReactionLocation).PAGE,
        containerId: spaceId,
        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
        contentSubType: isLivePage ? (0, $83sfO.LIVE_PAGE_SUBTYPE) : null,
        summaryViewEnabled: true,
        summaryViewThreshold: 1,
        allowSelectFromSummaryView: true,
        useButtonAlignmentStyling: true,
        summaryViewPlacement: "bottom-start",
        readOnly: isDisabled,
        isViewOnly: isDisabled,
        isSubtle: true,
        reactionPickerTriggerIcon: customIcon,
        reactionPickerTriggerText: formatMessage($06f66a283e23582e$var$i18n.addNew),
        useDefaultStyledContainer: true,
        hidePlaceholder: isSSR,
        noRelativeContainer: true,
        noFlexWrap: true,
        hoverableSummaryView: true,
        optimisticallyLoadSummaryEmojis: isSSR,
        renderParticleEffectOnSummaryView: true,
        bylineContainerRef: editorBylineContainerRef,
        renderParticleEffectOnLoad: isEligibleReactionsFeedbackPageReturn
    }), isEligibleReactionsFeedbackPageReturn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f66a283e23582e$var$dotStyles,
        testId: "reactions-feedback-experiment-live-dot"
    }));
};



var $fImWv = parcelRequire("fImWv");


var $04VgG = parcelRequire("04VgG");





var $5vi32 = parcelRequire("5vi32");








var $a9SX7 = parcelRequire("a9SX7");


var $JTIzG = parcelRequire("JTIzG");


var $8h2Hn = parcelRequire("8h2Hn");


var $LSims = parcelRequire("LSims");








var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $6qdjm = parcelRequire("6qdjm");


var $3gadb = parcelRequire("3gadb");














var $bQm3c = parcelRequire("bQm3c");


var $AavAW = parcelRequire("AavAW");


var $9BupY = parcelRequire("9BupY");

const $dce34ae8b4376c02$var$i18n = (0, $aXWIB.defineMessages)({
    recentFriendlyWhen: {
        id: "content-header.by-line.live-pages.last.updated.friendly.just.now",
        defaultMessage: "Just now"
    },
    tooltipWhen: {
        id: "content-header.by-line.live-pages.last.updated.tooltip",
        defaultMessage: "Last updated: {day} at {time}"
    }
});
const $dce34ae8b4376c02$export$e4a26074619839f4 = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, editorApi: editorApi })=>{
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $9BupY.default), {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        // sets loading to true when refetching, necessary for tooltip
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network' // query is preloaded on SSR, but not for SPA
        ,
        __callerPackage__: "@confluence/content-header"
    });
    const latestVersion = data?.content?.nodes?.[0]?.version;
    // We need version in a state variable separate from query data, in order to set it on debouncedSetRecentVersion
    const [version, setVersion] = (0, $42omo.useState)({
        friendlyWhen: latestVersion?.friendlyWhen || null,
        when: latestVersion?.when || null
    });
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const intl = (0, $aXWIB.useIntl)();
    // Medium dateStyle does not support 'at' combiner, so we're using separate date/time formatters
    const dayFormatter = Intl.DateTimeFormat(locale, {
        dateStyle: 'medium'
    });
    const timeFormatter = Intl.DateTimeFormat(locale, {
        timeStyle: 'short'
    });
    (0, $42omo.useEffect)(()=>{
        // Only show the latest version, which could be from the query or from debouncedSetRecentVersion
        if (latestVersion && JSON.stringify(latestVersion) !== JSON.stringify(version) && latestVersion.when && latestVersion.when >= (version?.when ?? '0')) setVersion({
            friendlyWhen: latestVersion.friendlyWhen ?? null,
            when: latestVersion.when ?? null
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to trigger this on data change
    }, [
        latestVersion
    ]);
    // Fetch that is immediately invoked before the debounced wait period
    // Used on visibility change (when user switches to this tab) and mouseenter
    const debouncedLeadingFetch = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(refetch, 60000, {
            leading: true,
            trailing: false,
            maxWait: 60000
        }), [
        refetch
    ]);
    (0, $42omo.useEffect)(()=>{
        // Fetch last updated time when tab is focused
        const handleVisibilityChange = async ()=>{
            if (document.visibilityState === 'visible') debouncedLeadingFetch(); // Get latest value when user switches back to this tab
        };
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        debouncedLeadingFetch
    ]);
    // After a page edit, we know the last change was very recent, so we directly set the version and skip
    // fetching over the network. We still debounce this to avoid rapid calls and prevent perfromance lag
    // when a user starts typing on very large pages
    const debouncedSetRecentVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setVersion({
                friendlyWhen: intl.formatMessage($dce34ae8b4376c02$var$i18n.recentFriendlyWhen),
                when: new Date().toISOString()
            });
        }, 3000), [
        setVersion,
        intl
    ]);
    // Update time stamp to "Just now" on page edit
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    // Cancel any pending timers on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            debouncedLeadingFetch.cancel();
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedLeadingFetch,
        debouncedSetRecentVersion
    ]);
    const tooltipContent = (0, $42omo.useMemo)(()=>{
        if (loading) return null;
        else if (version?.when) {
            // When time since last update is > 48 hours ago, friendlyWhen will be a date (i.e. Oct 31, 2024)
            // However, user time zone conversion of the friendlyWhen date is not currently working on the BE,
            // which means the localized date in the tooltip can differ from the UTC date in the byline.
            // To fix this discrepancy, for now we'll not show the tooltip for dates > 48 hours
            const date = new Date(version?.when);
            const twoDaysInMillis = 172800000;
            if (Date.now() - date.getTime() > twoDaysInMillis) return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$dce34ae8b4376c02$var$i18n.tooltipWhen,
                values: {
                    day: dayFormatter.format(date),
                    time: timeFormatter.format(date)
                }
            });
        }
    }, [
        loading,
        version?.when,
        dayFormatter,
        timeFormatter
    ]);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
        // so returning empty `<ErrorDisplay>` here.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    const handleTooltipShow = ()=>{
        debouncedLeadingFetch();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LivePagesByLineLastUpdated',
                action: 'displayed',
                actionSubject: 'tooltip',
                actionSubjectId: 'bylineLastUpdate',
                attributes: {
                    contentId: contentId,
                    isLivePage: true
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        onShow: handleTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
        version: version,
        loading: loading
    }));
});



var $aKxcs = parcelRequire("aKxcs");


var $6iOCg = parcelRequire("6iOCg");


var $5YSiR = parcelRequire("5YSiR");


var $3TrzI = parcelRequire("3TrzI");

const $3db5129918072e70$export$a6a69f624b6c8259 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(84);
    const { contentId: contentId, author: author, owner: owner, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, generatedBy: generatedBy, isCurrentUserContributor: isCurrentUserContributor, editorBylineContainerRef: t1 } = t0;
    const editorBylineContainerRef = t1 === undefined ? undefined : t1;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const { approvalRequest: approvalRequest, availableWorkflowStatuses: availableWorkflowStatuses } = (0, $laFNM.useApprovals)();
    let t2;
    if ($[0] !== approvalRequest || $[1] !== availableWorkflowStatuses) {
        t2 = !!approvalRequest?.application?.workflowStatusId && availableWorkflowStatuses.some((s)=>s.id === approvalRequest.application.workflowStatusId) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[0] = approvalRequest;
        $[1] = availableWorkflowStatuses;
        $[2] = t2;
    } else t2 = $[2];
    const hasActiveWorkflowStatus = t2;
    const { isAudioV3Enabled: isAudioV3Enabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId,
            isDraft: true
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = {
            fetchPolicy: "cache-first",
            variables: t3,
            skip: !Boolean(window.__SSR_RENDERED__)
        };
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6900e8f8fbd4b479$export$2e2bcd8739ae039), {
        ...t4,
        __callerPackage__: "@confluence/content-header"
    });
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const eligibleForReactions = isEmbeddedConfluence ? hasReactions : true;
    const renderReactions = (isLivePage || !isUnpublishedDraft) && eligibleForReactions;
    const t5 = renderReactions ? undefined : "space.050";
    let t6;
    if ($[7] !== author || $[8] !== contributorCountWithoutOwner || $[9] !== generatedBy || $[10] !== owner) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "liveDoc",
            contributorCountWithoutOwner: contributorCountWithoutOwner,
            generatedBy: generatedBy
        });
        $[7] = author;
        $[8] = contributorCountWithoutOwner;
        $[9] = generatedBy;
        $[10] = owner;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: t5
        }, t6);
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    const singleLineOwnershipByline = t7;
    const shouldHideMarkdownModeOptions = isMarkdownMode;
    const showByLineExtensions = isEmbeddedConfluence ? hasByLineExtensions : true;
    const showThirdPartyByLineExtensions = showByLineExtensions && !shouldHideMarkdownModeOptions;
    let t8;
    if ($[15] !== generatedBy || $[16] !== isEmbeddedConfluence) {
        t8 = generatedBy === (0, $3TrzI.AI_PLANNER_GENERATED_BY) && (0, $9wGTI.fg)("confluence_ai_planner_sync_byline") && !isEmbeddedConfluence;
        $[15] = generatedBy;
        $[16] = isEmbeddedConfluence;
        $[17] = t8;
    } else t8 = $[17];
    const shouldRenderAIPlannerSyncByline = t8;
    let t9;
    if ($[18] !== contentId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId
        });
        $[18] = contentId;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            (0, $bJX6u.ContentStateStateContainer)
        ];
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== contentId || $[22] !== contentType || $[23] !== data?.singleContent?.contentState || $[24] !== hasActiveWorkflowStatus || $[25] !== isKnowledgeBaseSpace || $[26] !== isLivePage || $[27] !== isPublishingContent || $[28] !== userOffline || $[29] !== viewMode) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t10
        }, (contentStateState)=>{
            if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63EIj.RendererContentState), {
                contentId: contentId,
                hasSeparator: false,
                isDraft: !isLivePage
            });
            const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
            if (contentStateState.state.contentState || hasActiveWorkflowStatus || isKnowledgeBaseSpace || isSSRRenderedOnLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                floatingToolbarButtonStyle: {
                    alignItems: "center",
                    height: "24px"
                },
                isViewMode: viewMode ?? false
            });
            else return null;
        });
        $[21] = contentId;
        $[22] = contentType;
        $[23] = data?.singleContent?.contentState;
        $[24] = hasActiveWorkflowStatus;
        $[25] = isKnowledgeBaseSpace;
        $[26] = isLivePage;
        $[27] = isPublishingContent;
        $[28] = userOffline;
        $[29] = viewMode;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== contentId || $[32] !== editorApi || $[33] !== isLivePage) {
        t12 = isLivePage && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dce34ae8b4376c02$export$e4a26074619839f4), {
            contentId: contentId,
            editorApi: editorApi
        });
        $[31] = contentId;
        $[32] = editorApi;
        $[33] = isLivePage;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== contentId || $[36] !== editorApi || $[37] !== shouldHideMarkdownModeOptions) {
        t13 = !shouldHideMarkdownModeOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
            contentId: contentId,
            editorApi: editorApi,
            isInEditor: true
        });
        $[35] = contentId;
        $[36] = editorApi;
        $[37] = shouldHideMarkdownModeOptions;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== contentId) {
        t14 = (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8h2Hn.BylineConnections), {
            contentId: contentId
        });
        $[39] = contentId;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== contentId || $[42] !== contentType || $[43] !== isAudioBylineEntrypointEnabled || $[44] !== isAudioV3Enabled || $[45] !== shouldHideMarkdownModeOptions) {
        t15 = isAudioV3Enabled && isAudioBylineEntrypointEnabled && !shouldHideMarkdownModeOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType
        });
        $[41] = contentId;
        $[42] = contentType;
        $[43] = isAudioBylineEntrypointEnabled;
        $[44] = isAudioV3Enabled;
        $[45] = shouldHideMarkdownModeOptions;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== author || $[48] !== contentId || $[49] !== isLivePage || $[50] !== isUnpublishedDraft) {
        t16 = (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fImWv.AnalyticsByLine), {
            contentId: contentId,
            contentAuthorId: author.userId
        });
        $[47] = author;
        $[48] = contentId;
        $[49] = isLivePage;
        $[50] = isUnpublishedDraft;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== t11 || $[53] !== t12 || $[54] !== t13 || $[55] !== t14 || $[56] !== t15 || $[57] !== t16 || $[58] !== t9) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, t11, t12, t13, t14, t15, t16);
        $[52] = t11;
        $[53] = t12;
        $[54] = t13;
        $[55] = t14;
        $[56] = t15;
        $[57] = t16;
        $[58] = t9;
        $[59] = t17;
    } else t17 = $[59];
    const byLineExtensions = t17;
    const t18 = showByLineExtensions && byLineExtensions;
    let t19;
    if ($[60] !== contentId || $[61] !== contentType || $[62] !== editorBylineContainerRef || $[63] !== isCurrentUserContributor || $[64] !== renderReactions || $[65] !== spaceId || $[66] !== userOffline) {
        t19 = renderReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06f66a283e23582e$export$37ba4ba009bc421f), {
            contentId: contentId,
            spaceId: spaceId || "",
            isDisabled: userOffline,
            contentType: contentType,
            isCurrentUserContributor: isCurrentUserContributor,
            editorBylineContainerRef: editorBylineContainerRef
        });
        $[60] = contentId;
        $[61] = contentType;
        $[62] = editorBylineContainerRef;
        $[63] = isCurrentUserContributor;
        $[64] = renderReactions;
        $[65] = spaceId;
        $[66] = userOffline;
        $[67] = t19;
    } else t19 = $[67];
    let t20;
    if ($[68] !== t18 || $[69] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t18, t19);
        $[68] = t18;
        $[69] = t19;
        $[70] = t20;
    } else t20 = $[70];
    const ByLineCommonContent = t20;
    const showByLineContributors = isEmbeddedConfluence ? hasByLineContributors : true;
    const t21 = contentType;
    const t22 = showByLineContributors && singleLineOwnershipByline;
    let t23;
    if ($[71] !== contentId || $[72] !== contentType || $[73] !== generatedBy || $[74] !== isEmbeddedConfluence || $[75] !== shouldRenderAIPlannerSyncByline) {
        t23 = shouldRenderAIPlannerSyncByline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5YSiR.LazyAIPlannerSyncByline), {
            contentId: contentId,
            contentType: contentType,
            generatedBy: generatedBy,
            isEmbeddedConfluence: isEmbeddedConfluence
        });
        $[71] = contentId;
        $[72] = contentType;
        $[73] = generatedBy;
        $[74] = isEmbeddedConfluence;
        $[75] = shouldRenderAIPlannerSyncByline;
        $[76] = t23;
    } else t23 = $[76];
    let t24;
    if ($[77] !== ByLineCommonContent || $[78] !== contentId || $[79] !== showThirdPartyByLineExtensions || $[80] !== t21 || $[81] !== t22 || $[82] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            contentType: t21,
            showByLineExtensions: showThirdPartyByLineExtensions
        }, t22, t23, ByLineCommonContent);
        $[77] = ByLineCommonContent;
        $[78] = contentId;
        $[79] = showThirdPartyByLineExtensions;
        $[80] = t21;
        $[81] = t22;
        $[82] = t23;
        $[83] = t24;
    } else t24 = $[83];
    return t24;
});



var $ausiN = parcelRequire("ausiN");


var $83fWZ = parcelRequire("83fWZ");

const $d898e2893b08edbf$export$7ee26dfdd6e2e40f = ({ contentId: contentId, contentType: contentType, viewMode: viewMode, isPublishingContent: isPublishingContent, isKnowledgeBaseSpace: isKnowledgeBaseSpace, userOffline: userOffline, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, editorBylineContainerRef: editorBylineContainerRef })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const lastLoadedQueryData = (0, $42omo.useRef)(null);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $fxLAA.default), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
            ...isUnpublishedDraft && !isLivePage && {
                status: [
                    'draft'
                ]
            }
        },
        context: {
            single: true
        },
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "@confluence/content-header"
    });
    const renderByLine = ()=>{
        // HACK: status: ['draft'] for unpublished drafts results in a weird case where loading is true and we also have the data. Need to investigate this further, but this hack should work for now.
        // happens because isUnpublishedDraft goes from false to true during SSR. ideally we would either always get the right data, or not need it (pass status: ['draft', 'current'] all the time - which could cause caching issues)
        const hasSSRData = renderServerPlaceholder && Boolean(data);
        if (loading && !hasSSRData) {
            // If we're loading because the LivePagesByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = data?.content?.nodes?.[0];
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const contributorProps = $d898e2893b08edbf$export$6dbfb663651d0abf(content, data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3db5129918072e70$export$a6a69f624b6c8259), {
            ...contributorProps,
            contentId: contentId,
            contentType: contentType,
            viewMode: viewMode,
            isPublishingContent: isPublishingContent,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            userOffline: userOffline,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions,
            editorBylineContainerRef: editorBylineContainerRef
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, renderByLine());
};
const $d898e2893b08edbf$export$6dbfb663651d0abf = (content, data)=>{
    const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
    const owner = content?.history?.ownedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
    const contributorsCount = data?.contentContributors?.count || 0;
    const isOwnerContributor = data?.contentContributors?.isOwnerContributor;
    const generatedBy = content?.contentProperties?.latest?.generatedBy;
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor || false;
    return {
        author: author,
        owner: owner,
        contributorsCount: contributorsCount,
        isOwnerContributor: isOwnerContributor,
        generatedBy: generatedBy,
        isCurrentUserContributor: isCurrentUserContributor
    };
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d54487d18f54cde1$var$EditorByLineWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d54487d18f54cde1$export$a5fad03eb2e226dc = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const editorBylineContainerRef = (0, $42omo.useRef)(null);
    if (isSpaceOverview) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6mKj3.expValEquals)("cc_editor_two_stage_hydration_removal", "editorByLineArea", true);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== contentType || $[3] !== editorApi || $[4] !== hasByLineContributors || $[5] !== hasByLineExtensions || $[6] !== hasReactions || $[7] !== isKnowledgeBaseSpace || $[8] !== isPublishingContent || $[9] !== isUnpublishedDraft || $[10] !== userOffline || $[11] !== viewMode) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d898e2893b08edbf$export$7ee26dfdd6e2e40f), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            viewMode: viewMode,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions,
            editorBylineContainerRef: editorBylineContainerRef
        });
        $[1] = contentId;
        $[2] = contentType;
        $[3] = editorApi;
        $[4] = hasByLineContributors;
        $[5] = hasByLineExtensions;
        $[6] = hasReactions;
        $[7] = isKnowledgeBaseSpace;
        $[8] = isPublishingContent;
        $[9] = isUnpublishedDraft;
        $[10] = userOffline;
        $[11] = viewMode;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== ssrPlaceholderIdProp || $[14] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
            name: "editor-byline",
            enabled: !t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
            "data-vc": "editor-byline-wrapper",
            ...ssrPlaceholderIdProp,
            ref: editorBylineContainerRef
        }, t2));
        $[13] = ssrPlaceholderIdProp;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
};
module.exports["EditorByLineArea"] = $d54487d18f54cde1$export$a5fad03eb2e226dc;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("e6vsp"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("e6vsp", function(module, exports) {

let $a44a06fe2f01a381$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a44a06fe2f01a381$var$load("fFc5s"),
    $a44a06fe2f01a381$var$load("9opeZ")
]).then(()=>parcelRequire('44FvL'));

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("ltleW"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("ltleW", function(module, exports) {

let $fa1cc83722b7b1b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fa1cc83722b7b1b3$var$load("fFc5s"),
    $fa1cc83722b7b1b3$var$load("el56J"),
    $fa1cc83722b7b1b3$var$load("hhss7"),
    $fa1cc83722b7b1b3$var$load("guVy6"),
    $fa1cc83722b7b1b3$var$load("7s1i1"),
    $fa1cc83722b7b1b3$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("JTIzG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const isAHMOnlyEnabled = (0, $42omo.useMemo)(()=>isAtlassianHostedLLMOnlyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_disable_if_ahm_enabled'), [
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAIPolicyAndBrowserSupportEnabled = (0, $42omo.useMemo)(()=>isAdminHubAIEnabled && // AdminHub AI is enabled
        isAIEarlyAccessEnabled && // AI Early Access is enabled
        audioSupportedByBrowser && // Audio is supported by browser
        !isAHMOnlyEnabled, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        audioSupportedByBrowser,
        isAHMOnlyEnabled
    ]);
    const isAudioV3Enabled = (0, $42omo.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const isAudioBylineEntrypointEnabled = (0, $42omo.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_ai_consumption_byline'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const audioBriefingNudgeExperimentState = (0, $42omo.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("LSims", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "@confluence/content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<97f042394447b34381d2572432982113>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $j7K0C = parcelRequire("j7K0C");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j7K0C))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("j7K0C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac59572d5177720dc1f7db0f6832687d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dec25c3798de43c2$var$_react = $dec25c3798de43c2$var$_interopRequireDefault((parcelRequire("42omo")));

var $dec25c3798de43c2$var$_baseNew = $dec25c3798de43c2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dec25c3798de43c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dec25c3798de43c2$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $dec25c3798de43c2$var$_react.default.createElement($dec25c3798de43c2$var$_baseNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$dec25c3798de43c2$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $dec25c3798de43c2$var$_default = module.exports.default = $dec25c3798de43c2$var$FileMarkdownIcon;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $42omo.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("95iK3"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("7BtEX"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("eFgJx"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("eejTL"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("j6msT"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("dHsrc"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("eMVec"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("69aza"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("9HBm6"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6unBl"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("1drOe"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("a7vXy"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("95iK3", function(module, exports) {

let $69d31e70913b68bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69d31e70913b68bb$var$load("2YffH"),
    $69d31e70913b68bb$var$load("gNfuQ"),
    $69d31e70913b68bb$var$load("eNXrl"),
    $69d31e70913b68bb$var$load("h6MOP"),
    $69d31e70913b68bb$var$load("gaF3h"),
    $69d31e70913b68bb$var$load("dZsGY"),
    $69d31e70913b68bb$var$load("eXKRO"),
    $69d31e70913b68bb$var$load("eBRUf"),
    $69d31e70913b68bb$var$load("5yluq"),
    $69d31e70913b68bb$var$load("2tcSk"),
    $69d31e70913b68bb$var$load("hUmZG"),
    $69d31e70913b68bb$var$load("h4Nf7"),
    $69d31e70913b68bb$var$load("8YSo7"),
    $69d31e70913b68bb$var$load("h9S8v"),
    $69d31e70913b68bb$var$load("dl2qY"),
    $69d31e70913b68bb$var$load("kL5FA"),
    $69d31e70913b68bb$var$load("cHb2G"),
    $69d31e70913b68bb$var$load("g4qer"),
    $69d31e70913b68bb$var$load("3GuOt"),
    $69d31e70913b68bb$var$load("jbM5v"),
    $69d31e70913b68bb$var$load("dek7I"),
    $69d31e70913b68bb$var$load("dYtBN"),
    $69d31e70913b68bb$var$load("kNV5Y"),
    $69d31e70913b68bb$var$load("6SWFK"),
    $69d31e70913b68bb$var$load("5zapo"),
    $69d31e70913b68bb$var$load("3MYQs"),
    $69d31e70913b68bb$var$load("9atVd"),
    $69d31e70913b68bb$var$load("6wr18"),
    $69d31e70913b68bb$var$load("gT8XU"),
    $69d31e70913b68bb$var$load("53AGa"),
    $69d31e70913b68bb$var$load("8bhm4"),
    $69d31e70913b68bb$var$load("5wVuh"),
    $69d31e70913b68bb$var$load("4NznW"),
    $69d31e70913b68bb$var$load("gBV5J"),
    $69d31e70913b68bb$var$load("djjX5"),
    $69d31e70913b68bb$var$load("cX4Bp"),
    $69d31e70913b68bb$var$load("dawn8"),
    $69d31e70913b68bb$var$load("ffEVr"),
    $69d31e70913b68bb$var$load("aQh37"),
    $69d31e70913b68bb$var$load("bJVDE"),
    $69d31e70913b68bb$var$load("4XdkL"),
    $69d31e70913b68bb$var$load("4eock"),
    $69d31e70913b68bb$var$load("8k9aB"),
    $69d31e70913b68bb$var$load("fLwVm"),
    $69d31e70913b68bb$var$load("1bbSu"),
    $69d31e70913b68bb$var$load("kuFG2"),
    $69d31e70913b68bb$var$load("b9CA3"),
    $69d31e70913b68bb$var$load("Wowvf"),
    $69d31e70913b68bb$var$load("1F7LX"),
    $69d31e70913b68bb$var$load("jZLnv"),
    $69d31e70913b68bb$var$load("6edij"),
    $69d31e70913b68bb$var$load("3QXpo"),
    $69d31e70913b68bb$var$load("hhss7"),
    $69d31e70913b68bb$var$load("fuks3"),
    $69d31e70913b68bb$var$load("lnKog"),
    $69d31e70913b68bb$var$load("h3ABO"),
    $69d31e70913b68bb$var$load("kC80R"),
    $69d31e70913b68bb$var$load("7EorR"),
    $69d31e70913b68bb$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("7BtEX", function(module, exports) {

let $5892fee12e853d36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5892fee12e853d36$var$load("2YffH"),
    $5892fee12e853d36$var$load("gNfuQ"),
    $5892fee12e853d36$var$load("eNXrl"),
    $5892fee12e853d36$var$load("h6MOP"),
    $5892fee12e853d36$var$load("gaF3h"),
    $5892fee12e853d36$var$load("dZsGY"),
    $5892fee12e853d36$var$load("eXKRO"),
    $5892fee12e853d36$var$load("eBRUf"),
    $5892fee12e853d36$var$load("5yluq"),
    $5892fee12e853d36$var$load("2tcSk"),
    $5892fee12e853d36$var$load("hUmZG"),
    $5892fee12e853d36$var$load("h4Nf7"),
    $5892fee12e853d36$var$load("8YSo7"),
    $5892fee12e853d36$var$load("h9S8v"),
    $5892fee12e853d36$var$load("dl2qY"),
    $5892fee12e853d36$var$load("kL5FA"),
    $5892fee12e853d36$var$load("cHb2G"),
    $5892fee12e853d36$var$load("g4qer"),
    $5892fee12e853d36$var$load("3GuOt"),
    $5892fee12e853d36$var$load("jbM5v"),
    $5892fee12e853d36$var$load("dek7I"),
    $5892fee12e853d36$var$load("dYtBN"),
    $5892fee12e853d36$var$load("kNV5Y"),
    $5892fee12e853d36$var$load("6SWFK"),
    $5892fee12e853d36$var$load("5zapo"),
    $5892fee12e853d36$var$load("3MYQs"),
    $5892fee12e853d36$var$load("9atVd"),
    $5892fee12e853d36$var$load("6wr18"),
    $5892fee12e853d36$var$load("gT8XU"),
    $5892fee12e853d36$var$load("53AGa"),
    $5892fee12e853d36$var$load("8bhm4"),
    $5892fee12e853d36$var$load("5wVuh"),
    $5892fee12e853d36$var$load("4NznW"),
    $5892fee12e853d36$var$load("gBV5J"),
    $5892fee12e853d36$var$load("djjX5"),
    $5892fee12e853d36$var$load("cX4Bp"),
    $5892fee12e853d36$var$load("dawn8"),
    $5892fee12e853d36$var$load("ffEVr"),
    $5892fee12e853d36$var$load("aQh37"),
    $5892fee12e853d36$var$load("bJVDE"),
    $5892fee12e853d36$var$load("4XdkL"),
    $5892fee12e853d36$var$load("4eock"),
    $5892fee12e853d36$var$load("8k9aB"),
    $5892fee12e853d36$var$load("fLwVm"),
    $5892fee12e853d36$var$load("1bbSu"),
    $5892fee12e853d36$var$load("kuFG2"),
    $5892fee12e853d36$var$load("b9CA3"),
    $5892fee12e853d36$var$load("Wowvf"),
    $5892fee12e853d36$var$load("1F7LX"),
    $5892fee12e853d36$var$load("jZLnv"),
    $5892fee12e853d36$var$load("6edij"),
    $5892fee12e853d36$var$load("3QXpo"),
    $5892fee12e853d36$var$load("hhss7"),
    $5892fee12e853d36$var$load("fuks3"),
    $5892fee12e853d36$var$load("lnKog"),
    $5892fee12e853d36$var$load("h3ABO"),
    $5892fee12e853d36$var$load("kC80R"),
    $5892fee12e853d36$var$load("7EorR"),
    $5892fee12e853d36$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("eFgJx", function(module, exports) {

let $aad1dfef493cf195$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aad1dfef493cf195$var$load("2YffH"),
    $aad1dfef493cf195$var$load("gNfuQ"),
    $aad1dfef493cf195$var$load("eNXrl"),
    $aad1dfef493cf195$var$load("h6MOP"),
    $aad1dfef493cf195$var$load("gaF3h"),
    $aad1dfef493cf195$var$load("dZsGY"),
    $aad1dfef493cf195$var$load("eXKRO"),
    $aad1dfef493cf195$var$load("eBRUf"),
    $aad1dfef493cf195$var$load("5yluq"),
    $aad1dfef493cf195$var$load("2tcSk"),
    $aad1dfef493cf195$var$load("hUmZG"),
    $aad1dfef493cf195$var$load("h4Nf7"),
    $aad1dfef493cf195$var$load("8YSo7"),
    $aad1dfef493cf195$var$load("h9S8v"),
    $aad1dfef493cf195$var$load("dl2qY"),
    $aad1dfef493cf195$var$load("kL5FA"),
    $aad1dfef493cf195$var$load("cHb2G"),
    $aad1dfef493cf195$var$load("g4qer"),
    $aad1dfef493cf195$var$load("3GuOt"),
    $aad1dfef493cf195$var$load("jbM5v"),
    $aad1dfef493cf195$var$load("dek7I"),
    $aad1dfef493cf195$var$load("dYtBN"),
    $aad1dfef493cf195$var$load("kNV5Y"),
    $aad1dfef493cf195$var$load("6SWFK"),
    $aad1dfef493cf195$var$load("5zapo"),
    $aad1dfef493cf195$var$load("3MYQs"),
    $aad1dfef493cf195$var$load("9atVd"),
    $aad1dfef493cf195$var$load("6wr18"),
    $aad1dfef493cf195$var$load("gT8XU"),
    $aad1dfef493cf195$var$load("53AGa"),
    $aad1dfef493cf195$var$load("8bhm4"),
    $aad1dfef493cf195$var$load("5wVuh"),
    $aad1dfef493cf195$var$load("4NznW"),
    $aad1dfef493cf195$var$load("gBV5J"),
    $aad1dfef493cf195$var$load("djjX5"),
    $aad1dfef493cf195$var$load("cX4Bp"),
    $aad1dfef493cf195$var$load("dawn8"),
    $aad1dfef493cf195$var$load("ffEVr"),
    $aad1dfef493cf195$var$load("aQh37"),
    $aad1dfef493cf195$var$load("bJVDE"),
    $aad1dfef493cf195$var$load("4XdkL"),
    $aad1dfef493cf195$var$load("4eock"),
    $aad1dfef493cf195$var$load("8k9aB"),
    $aad1dfef493cf195$var$load("fLwVm"),
    $aad1dfef493cf195$var$load("1bbSu"),
    $aad1dfef493cf195$var$load("kuFG2"),
    $aad1dfef493cf195$var$load("b9CA3"),
    $aad1dfef493cf195$var$load("Wowvf"),
    $aad1dfef493cf195$var$load("1F7LX"),
    $aad1dfef493cf195$var$load("jZLnv"),
    $aad1dfef493cf195$var$load("6edij"),
    $aad1dfef493cf195$var$load("3QXpo"),
    $aad1dfef493cf195$var$load("hhss7"),
    $aad1dfef493cf195$var$load("fuks3"),
    $aad1dfef493cf195$var$load("lnKog"),
    $aad1dfef493cf195$var$load("h3ABO"),
    $aad1dfef493cf195$var$load("kC80R"),
    $aad1dfef493cf195$var$load("7EorR"),
    $aad1dfef493cf195$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("eejTL", function(module, exports) {

let $a5c1cee34eb100dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a5c1cee34eb100dc$var$load("8k9aB"),
    $a5c1cee34eb100dc$var$load("fLwVm"),
    $a5c1cee34eb100dc$var$load("2YffH"),
    $a5c1cee34eb100dc$var$load("h6MOP"),
    $a5c1cee34eb100dc$var$load("gaF3h"),
    $a5c1cee34eb100dc$var$load("eXKRO"),
    $a5c1cee34eb100dc$var$load("eBRUf"),
    $a5c1cee34eb100dc$var$load("5yluq"),
    $a5c1cee34eb100dc$var$load("2tcSk"),
    $a5c1cee34eb100dc$var$load("hUmZG"),
    $a5c1cee34eb100dc$var$load("h4Nf7"),
    $a5c1cee34eb100dc$var$load("8YSo7"),
    $a5c1cee34eb100dc$var$load("dl2qY"),
    $a5c1cee34eb100dc$var$load("kL5FA"),
    $a5c1cee34eb100dc$var$load("cHb2G"),
    $a5c1cee34eb100dc$var$load("g4qer"),
    $a5c1cee34eb100dc$var$load("3GuOt"),
    $a5c1cee34eb100dc$var$load("jbM5v"),
    $a5c1cee34eb100dc$var$load("6SWFK"),
    $a5c1cee34eb100dc$var$load("5zapo"),
    $a5c1cee34eb100dc$var$load("3MYQs"),
    $a5c1cee34eb100dc$var$load("6wr18"),
    $a5c1cee34eb100dc$var$load("9atVd"),
    $a5c1cee34eb100dc$var$load("53AGa"),
    $a5c1cee34eb100dc$var$load("8bhm4"),
    $a5c1cee34eb100dc$var$load("gBV5J"),
    $a5c1cee34eb100dc$var$load("djjX5"),
    $a5c1cee34eb100dc$var$load("cX4Bp"),
    $a5c1cee34eb100dc$var$load("dawn8"),
    $a5c1cee34eb100dc$var$load("ffEVr"),
    $a5c1cee34eb100dc$var$load("aQh37"),
    $a5c1cee34eb100dc$var$load("bJVDE"),
    $a5c1cee34eb100dc$var$load("4XdkL"),
    $a5c1cee34eb100dc$var$load("4eock"),
    $a5c1cee34eb100dc$var$load("1bbSu"),
    $a5c1cee34eb100dc$var$load("kuFG2"),
    $a5c1cee34eb100dc$var$load("fuks3"),
    $a5c1cee34eb100dc$var$load("b9CA3"),
    $a5c1cee34eb100dc$var$load("Wowvf"),
    $a5c1cee34eb100dc$var$load("1F7LX"),
    $a5c1cee34eb100dc$var$load("jZLnv"),
    $a5c1cee34eb100dc$var$load("6edij"),
    $a5c1cee34eb100dc$var$load("3QXpo"),
    $a5c1cee34eb100dc$var$load("hhss7"),
    $a5c1cee34eb100dc$var$load("h3ABO"),
    $a5c1cee34eb100dc$var$load("kC80R"),
    $a5c1cee34eb100dc$var$load("7EorR"),
    $a5c1cee34eb100dc$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("j6msT", function(module, exports) {

let $de8000f3ee0a0f5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de8000f3ee0a0f5e$var$load("8k9aB"),
    $de8000f3ee0a0f5e$var$load("fLwVm"),
    $de8000f3ee0a0f5e$var$load("2YffH"),
    $de8000f3ee0a0f5e$var$load("h6MOP"),
    $de8000f3ee0a0f5e$var$load("gaF3h"),
    $de8000f3ee0a0f5e$var$load("eXKRO"),
    $de8000f3ee0a0f5e$var$load("eBRUf"),
    $de8000f3ee0a0f5e$var$load("5yluq"),
    $de8000f3ee0a0f5e$var$load("2tcSk"),
    $de8000f3ee0a0f5e$var$load("hUmZG"),
    $de8000f3ee0a0f5e$var$load("h4Nf7"),
    $de8000f3ee0a0f5e$var$load("8YSo7"),
    $de8000f3ee0a0f5e$var$load("dl2qY"),
    $de8000f3ee0a0f5e$var$load("kL5FA"),
    $de8000f3ee0a0f5e$var$load("cHb2G"),
    $de8000f3ee0a0f5e$var$load("g4qer"),
    $de8000f3ee0a0f5e$var$load("3GuOt"),
    $de8000f3ee0a0f5e$var$load("jbM5v"),
    $de8000f3ee0a0f5e$var$load("6SWFK"),
    $de8000f3ee0a0f5e$var$load("5zapo"),
    $de8000f3ee0a0f5e$var$load("3MYQs"),
    $de8000f3ee0a0f5e$var$load("6wr18"),
    $de8000f3ee0a0f5e$var$load("9atVd"),
    $de8000f3ee0a0f5e$var$load("53AGa"),
    $de8000f3ee0a0f5e$var$load("8bhm4"),
    $de8000f3ee0a0f5e$var$load("gBV5J"),
    $de8000f3ee0a0f5e$var$load("djjX5"),
    $de8000f3ee0a0f5e$var$load("cX4Bp"),
    $de8000f3ee0a0f5e$var$load("dawn8"),
    $de8000f3ee0a0f5e$var$load("ffEVr"),
    $de8000f3ee0a0f5e$var$load("aQh37"),
    $de8000f3ee0a0f5e$var$load("bJVDE"),
    $de8000f3ee0a0f5e$var$load("4XdkL"),
    $de8000f3ee0a0f5e$var$load("4eock"),
    $de8000f3ee0a0f5e$var$load("1bbSu"),
    $de8000f3ee0a0f5e$var$load("kuFG2"),
    $de8000f3ee0a0f5e$var$load("fuks3"),
    $de8000f3ee0a0f5e$var$load("b9CA3"),
    $de8000f3ee0a0f5e$var$load("Wowvf"),
    $de8000f3ee0a0f5e$var$load("1F7LX"),
    $de8000f3ee0a0f5e$var$load("jZLnv"),
    $de8000f3ee0a0f5e$var$load("6edij"),
    $de8000f3ee0a0f5e$var$load("3QXpo"),
    $de8000f3ee0a0f5e$var$load("hhss7"),
    $de8000f3ee0a0f5e$var$load("h3ABO"),
    $de8000f3ee0a0f5e$var$load("kC80R"),
    $de8000f3ee0a0f5e$var$load("7EorR"),
    $de8000f3ee0a0f5e$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("dHsrc", function(module, exports) {

let $9f9559ab17564f17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f9559ab17564f17$var$load("8k9aB"),
    $9f9559ab17564f17$var$load("fLwVm"),
    $9f9559ab17564f17$var$load("2YffH"),
    $9f9559ab17564f17$var$load("h6MOP"),
    $9f9559ab17564f17$var$load("gaF3h"),
    $9f9559ab17564f17$var$load("eXKRO"),
    $9f9559ab17564f17$var$load("eBRUf"),
    $9f9559ab17564f17$var$load("5yluq"),
    $9f9559ab17564f17$var$load("2tcSk"),
    $9f9559ab17564f17$var$load("hUmZG"),
    $9f9559ab17564f17$var$load("h4Nf7"),
    $9f9559ab17564f17$var$load("8YSo7"),
    $9f9559ab17564f17$var$load("dl2qY"),
    $9f9559ab17564f17$var$load("kL5FA"),
    $9f9559ab17564f17$var$load("cHb2G"),
    $9f9559ab17564f17$var$load("g4qer"),
    $9f9559ab17564f17$var$load("3GuOt"),
    $9f9559ab17564f17$var$load("jbM5v"),
    $9f9559ab17564f17$var$load("6SWFK"),
    $9f9559ab17564f17$var$load("5zapo"),
    $9f9559ab17564f17$var$load("3MYQs"),
    $9f9559ab17564f17$var$load("6wr18"),
    $9f9559ab17564f17$var$load("9atVd"),
    $9f9559ab17564f17$var$load("53AGa"),
    $9f9559ab17564f17$var$load("8bhm4"),
    $9f9559ab17564f17$var$load("gBV5J"),
    $9f9559ab17564f17$var$load("djjX5"),
    $9f9559ab17564f17$var$load("cX4Bp"),
    $9f9559ab17564f17$var$load("dawn8"),
    $9f9559ab17564f17$var$load("ffEVr"),
    $9f9559ab17564f17$var$load("aQh37"),
    $9f9559ab17564f17$var$load("bJVDE"),
    $9f9559ab17564f17$var$load("4XdkL"),
    $9f9559ab17564f17$var$load("4eock"),
    $9f9559ab17564f17$var$load("1bbSu"),
    $9f9559ab17564f17$var$load("kuFG2"),
    $9f9559ab17564f17$var$load("fuks3"),
    $9f9559ab17564f17$var$load("b9CA3"),
    $9f9559ab17564f17$var$load("Wowvf"),
    $9f9559ab17564f17$var$load("1F7LX"),
    $9f9559ab17564f17$var$load("jZLnv"),
    $9f9559ab17564f17$var$load("6edij"),
    $9f9559ab17564f17$var$load("3QXpo"),
    $9f9559ab17564f17$var$load("hhss7"),
    $9f9559ab17564f17$var$load("h3ABO"),
    $9f9559ab17564f17$var$load("kC80R"),
    $9f9559ab17564f17$var$load("7EorR"),
    $9f9559ab17564f17$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("eMVec", function(module, exports) {

let $ac41f0a9679c174a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac41f0a9679c174a$var$load("8k9aB"),
    $ac41f0a9679c174a$var$load("fLwVm"),
    $ac41f0a9679c174a$var$load("2YffH"),
    $ac41f0a9679c174a$var$load("h6MOP"),
    $ac41f0a9679c174a$var$load("gaF3h"),
    $ac41f0a9679c174a$var$load("eXKRO"),
    $ac41f0a9679c174a$var$load("eBRUf"),
    $ac41f0a9679c174a$var$load("5yluq"),
    $ac41f0a9679c174a$var$load("2tcSk"),
    $ac41f0a9679c174a$var$load("hUmZG"),
    $ac41f0a9679c174a$var$load("h4Nf7"),
    $ac41f0a9679c174a$var$load("8YSo7"),
    $ac41f0a9679c174a$var$load("dl2qY"),
    $ac41f0a9679c174a$var$load("kL5FA"),
    $ac41f0a9679c174a$var$load("cHb2G"),
    $ac41f0a9679c174a$var$load("g4qer"),
    $ac41f0a9679c174a$var$load("3GuOt"),
    $ac41f0a9679c174a$var$load("jbM5v"),
    $ac41f0a9679c174a$var$load("6SWFK"),
    $ac41f0a9679c174a$var$load("5zapo"),
    $ac41f0a9679c174a$var$load("3MYQs"),
    $ac41f0a9679c174a$var$load("6wr18"),
    $ac41f0a9679c174a$var$load("9atVd"),
    $ac41f0a9679c174a$var$load("53AGa"),
    $ac41f0a9679c174a$var$load("8bhm4"),
    $ac41f0a9679c174a$var$load("gBV5J"),
    $ac41f0a9679c174a$var$load("djjX5"),
    $ac41f0a9679c174a$var$load("cX4Bp"),
    $ac41f0a9679c174a$var$load("dawn8"),
    $ac41f0a9679c174a$var$load("ffEVr"),
    $ac41f0a9679c174a$var$load("aQh37"),
    $ac41f0a9679c174a$var$load("bJVDE"),
    $ac41f0a9679c174a$var$load("4XdkL"),
    $ac41f0a9679c174a$var$load("4eock"),
    $ac41f0a9679c174a$var$load("1bbSu"),
    $ac41f0a9679c174a$var$load("kuFG2"),
    $ac41f0a9679c174a$var$load("b9CA3"),
    $ac41f0a9679c174a$var$load("Wowvf"),
    $ac41f0a9679c174a$var$load("1F7LX"),
    $ac41f0a9679c174a$var$load("jZLnv"),
    $ac41f0a9679c174a$var$load("6edij"),
    $ac41f0a9679c174a$var$load("3QXpo"),
    $ac41f0a9679c174a$var$load("hhss7"),
    $ac41f0a9679c174a$var$load("fuks3"),
    $ac41f0a9679c174a$var$load("lnKog"),
    $ac41f0a9679c174a$var$load("h3ABO"),
    $ac41f0a9679c174a$var$load("kC80R"),
    $ac41f0a9679c174a$var$load("7EorR"),
    $ac41f0a9679c174a$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("69aza", function(module, exports) {

let $479bc78b89290c43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $479bc78b89290c43$var$load("2YffH"),
    $479bc78b89290c43$var$load("h6MOP"),
    $479bc78b89290c43$var$load("gaF3h"),
    $479bc78b89290c43$var$load("dZsGY"),
    $479bc78b89290c43$var$load("eXKRO"),
    $479bc78b89290c43$var$load("eBRUf"),
    $479bc78b89290c43$var$load("5yluq"),
    $479bc78b89290c43$var$load("2tcSk"),
    $479bc78b89290c43$var$load("hUmZG"),
    $479bc78b89290c43$var$load("h4Nf7"),
    $479bc78b89290c43$var$load("8YSo7"),
    $479bc78b89290c43$var$load("h9S8v"),
    $479bc78b89290c43$var$load("dl2qY"),
    $479bc78b89290c43$var$load("kL5FA"),
    $479bc78b89290c43$var$load("cHb2G"),
    $479bc78b89290c43$var$load("g4qer"),
    $479bc78b89290c43$var$load("3GuOt"),
    $479bc78b89290c43$var$load("jbM5v"),
    $479bc78b89290c43$var$load("dek7I"),
    $479bc78b89290c43$var$load("dYtBN"),
    $479bc78b89290c43$var$load("kNV5Y"),
    $479bc78b89290c43$var$load("6SWFK"),
    $479bc78b89290c43$var$load("5zapo"),
    $479bc78b89290c43$var$load("3MYQs"),
    $479bc78b89290c43$var$load("9atVd"),
    $479bc78b89290c43$var$load("6wr18"),
    $479bc78b89290c43$var$load("gT8XU"),
    $479bc78b89290c43$var$load("53AGa"),
    $479bc78b89290c43$var$load("8bhm4"),
    $479bc78b89290c43$var$load("5wVuh"),
    $479bc78b89290c43$var$load("4NznW"),
    $479bc78b89290c43$var$load("gBV5J"),
    $479bc78b89290c43$var$load("djjX5"),
    $479bc78b89290c43$var$load("cX4Bp"),
    $479bc78b89290c43$var$load("dawn8"),
    $479bc78b89290c43$var$load("ffEVr"),
    $479bc78b89290c43$var$load("aQh37"),
    $479bc78b89290c43$var$load("bJVDE"),
    $479bc78b89290c43$var$load("4XdkL"),
    $479bc78b89290c43$var$load("4eock"),
    $479bc78b89290c43$var$load("8k9aB"),
    $479bc78b89290c43$var$load("fLwVm"),
    $479bc78b89290c43$var$load("1bbSu"),
    $479bc78b89290c43$var$load("kuFG2"),
    $479bc78b89290c43$var$load("b9CA3"),
    $479bc78b89290c43$var$load("Wowvf"),
    $479bc78b89290c43$var$load("1F7LX"),
    $479bc78b89290c43$var$load("jZLnv"),
    $479bc78b89290c43$var$load("6edij"),
    $479bc78b89290c43$var$load("3QXpo"),
    $479bc78b89290c43$var$load("hhss7"),
    $479bc78b89290c43$var$load("fuks3"),
    $479bc78b89290c43$var$load("lnKog"),
    $479bc78b89290c43$var$load("h3ABO"),
    $479bc78b89290c43$var$load("kC80R"),
    $479bc78b89290c43$var$load("7EorR"),
    $479bc78b89290c43$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("9HBm6", function(module, exports) {

let $01d2a9bad7503092$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01d2a9bad7503092$var$load("2YffH"),
    $01d2a9bad7503092$var$load("h6MOP"),
    $01d2a9bad7503092$var$load("gaF3h"),
    $01d2a9bad7503092$var$load("dZsGY"),
    $01d2a9bad7503092$var$load("eXKRO"),
    $01d2a9bad7503092$var$load("eBRUf"),
    $01d2a9bad7503092$var$load("5yluq"),
    $01d2a9bad7503092$var$load("2tcSk"),
    $01d2a9bad7503092$var$load("hUmZG"),
    $01d2a9bad7503092$var$load("h4Nf7"),
    $01d2a9bad7503092$var$load("8YSo7"),
    $01d2a9bad7503092$var$load("h9S8v"),
    $01d2a9bad7503092$var$load("dl2qY"),
    $01d2a9bad7503092$var$load("kL5FA"),
    $01d2a9bad7503092$var$load("cHb2G"),
    $01d2a9bad7503092$var$load("g4qer"),
    $01d2a9bad7503092$var$load("3GuOt"),
    $01d2a9bad7503092$var$load("jbM5v"),
    $01d2a9bad7503092$var$load("dek7I"),
    $01d2a9bad7503092$var$load("dYtBN"),
    $01d2a9bad7503092$var$load("kNV5Y"),
    $01d2a9bad7503092$var$load("6SWFK"),
    $01d2a9bad7503092$var$load("5zapo"),
    $01d2a9bad7503092$var$load("3MYQs"),
    $01d2a9bad7503092$var$load("9atVd"),
    $01d2a9bad7503092$var$load("6wr18"),
    $01d2a9bad7503092$var$load("gT8XU"),
    $01d2a9bad7503092$var$load("53AGa"),
    $01d2a9bad7503092$var$load("8bhm4"),
    $01d2a9bad7503092$var$load("5wVuh"),
    $01d2a9bad7503092$var$load("4NznW"),
    $01d2a9bad7503092$var$load("gBV5J"),
    $01d2a9bad7503092$var$load("djjX5"),
    $01d2a9bad7503092$var$load("cX4Bp"),
    $01d2a9bad7503092$var$load("dawn8"),
    $01d2a9bad7503092$var$load("ffEVr"),
    $01d2a9bad7503092$var$load("aQh37"),
    $01d2a9bad7503092$var$load("bJVDE"),
    $01d2a9bad7503092$var$load("4XdkL"),
    $01d2a9bad7503092$var$load("4eock"),
    $01d2a9bad7503092$var$load("8k9aB"),
    $01d2a9bad7503092$var$load("fLwVm"),
    $01d2a9bad7503092$var$load("1bbSu"),
    $01d2a9bad7503092$var$load("kuFG2"),
    $01d2a9bad7503092$var$load("b9CA3"),
    $01d2a9bad7503092$var$load("Wowvf"),
    $01d2a9bad7503092$var$load("1F7LX"),
    $01d2a9bad7503092$var$load("jZLnv"),
    $01d2a9bad7503092$var$load("6edij"),
    $01d2a9bad7503092$var$load("3QXpo"),
    $01d2a9bad7503092$var$load("hhss7"),
    $01d2a9bad7503092$var$load("fuks3"),
    $01d2a9bad7503092$var$load("lnKog"),
    $01d2a9bad7503092$var$load("h3ABO"),
    $01d2a9bad7503092$var$load("kC80R"),
    $01d2a9bad7503092$var$load("7EorR"),
    $01d2a9bad7503092$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6unBl", function(module, exports) {

let $4b97da28121d55e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4b97da28121d55e9$var$load("8k9aB"),
    $4b97da28121d55e9$var$load("fLwVm"),
    $4b97da28121d55e9$var$load("2YffH"),
    $4b97da28121d55e9$var$load("h6MOP"),
    $4b97da28121d55e9$var$load("gaF3h"),
    $4b97da28121d55e9$var$load("eXKRO"),
    $4b97da28121d55e9$var$load("eBRUf"),
    $4b97da28121d55e9$var$load("5yluq"),
    $4b97da28121d55e9$var$load("2tcSk"),
    $4b97da28121d55e9$var$load("hUmZG"),
    $4b97da28121d55e9$var$load("h4Nf7"),
    $4b97da28121d55e9$var$load("8YSo7"),
    $4b97da28121d55e9$var$load("dl2qY"),
    $4b97da28121d55e9$var$load("kL5FA"),
    $4b97da28121d55e9$var$load("cHb2G"),
    $4b97da28121d55e9$var$load("g4qer"),
    $4b97da28121d55e9$var$load("3GuOt"),
    $4b97da28121d55e9$var$load("jbM5v"),
    $4b97da28121d55e9$var$load("6SWFK"),
    $4b97da28121d55e9$var$load("5zapo"),
    $4b97da28121d55e9$var$load("3MYQs"),
    $4b97da28121d55e9$var$load("6wr18"),
    $4b97da28121d55e9$var$load("9atVd"),
    $4b97da28121d55e9$var$load("53AGa"),
    $4b97da28121d55e9$var$load("8bhm4"),
    $4b97da28121d55e9$var$load("gBV5J"),
    $4b97da28121d55e9$var$load("djjX5"),
    $4b97da28121d55e9$var$load("cX4Bp"),
    $4b97da28121d55e9$var$load("dawn8"),
    $4b97da28121d55e9$var$load("ffEVr"),
    $4b97da28121d55e9$var$load("aQh37"),
    $4b97da28121d55e9$var$load("bJVDE"),
    $4b97da28121d55e9$var$load("4XdkL"),
    $4b97da28121d55e9$var$load("4eock"),
    $4b97da28121d55e9$var$load("1bbSu"),
    $4b97da28121d55e9$var$load("kuFG2"),
    $4b97da28121d55e9$var$load("fuks3"),
    $4b97da28121d55e9$var$load("b9CA3"),
    $4b97da28121d55e9$var$load("Wowvf"),
    $4b97da28121d55e9$var$load("1F7LX"),
    $4b97da28121d55e9$var$load("jZLnv"),
    $4b97da28121d55e9$var$load("6edij"),
    $4b97da28121d55e9$var$load("3QXpo"),
    $4b97da28121d55e9$var$load("hhss7"),
    $4b97da28121d55e9$var$load("h3ABO"),
    $4b97da28121d55e9$var$load("kC80R"),
    $4b97da28121d55e9$var$load("7EorR"),
    $4b97da28121d55e9$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("1drOe", function(module, exports) {

let $0e2c93ac2e2f89be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e2c93ac2e2f89be$var$load("8k9aB"),
    $0e2c93ac2e2f89be$var$load("fLwVm"),
    $0e2c93ac2e2f89be$var$load("2YffH"),
    $0e2c93ac2e2f89be$var$load("h6MOP"),
    $0e2c93ac2e2f89be$var$load("gaF3h"),
    $0e2c93ac2e2f89be$var$load("eXKRO"),
    $0e2c93ac2e2f89be$var$load("eBRUf"),
    $0e2c93ac2e2f89be$var$load("5yluq"),
    $0e2c93ac2e2f89be$var$load("2tcSk"),
    $0e2c93ac2e2f89be$var$load("hUmZG"),
    $0e2c93ac2e2f89be$var$load("h4Nf7"),
    $0e2c93ac2e2f89be$var$load("8YSo7"),
    $0e2c93ac2e2f89be$var$load("dl2qY"),
    $0e2c93ac2e2f89be$var$load("kL5FA"),
    $0e2c93ac2e2f89be$var$load("cHb2G"),
    $0e2c93ac2e2f89be$var$load("g4qer"),
    $0e2c93ac2e2f89be$var$load("3GuOt"),
    $0e2c93ac2e2f89be$var$load("jbM5v"),
    $0e2c93ac2e2f89be$var$load("6SWFK"),
    $0e2c93ac2e2f89be$var$load("5zapo"),
    $0e2c93ac2e2f89be$var$load("3MYQs"),
    $0e2c93ac2e2f89be$var$load("6wr18"),
    $0e2c93ac2e2f89be$var$load("9atVd"),
    $0e2c93ac2e2f89be$var$load("53AGa"),
    $0e2c93ac2e2f89be$var$load("8bhm4"),
    $0e2c93ac2e2f89be$var$load("gBV5J"),
    $0e2c93ac2e2f89be$var$load("djjX5"),
    $0e2c93ac2e2f89be$var$load("cX4Bp"),
    $0e2c93ac2e2f89be$var$load("dawn8"),
    $0e2c93ac2e2f89be$var$load("ffEVr"),
    $0e2c93ac2e2f89be$var$load("aQh37"),
    $0e2c93ac2e2f89be$var$load("bJVDE"),
    $0e2c93ac2e2f89be$var$load("4XdkL"),
    $0e2c93ac2e2f89be$var$load("4eock"),
    $0e2c93ac2e2f89be$var$load("1bbSu"),
    $0e2c93ac2e2f89be$var$load("kuFG2"),
    $0e2c93ac2e2f89be$var$load("b9CA3"),
    $0e2c93ac2e2f89be$var$load("Wowvf"),
    $0e2c93ac2e2f89be$var$load("1F7LX"),
    $0e2c93ac2e2f89be$var$load("jZLnv"),
    $0e2c93ac2e2f89be$var$load("6edij"),
    $0e2c93ac2e2f89be$var$load("3QXpo"),
    $0e2c93ac2e2f89be$var$load("hhss7"),
    $0e2c93ac2e2f89be$var$load("fuks3"),
    $0e2c93ac2e2f89be$var$load("lnKog"),
    $0e2c93ac2e2f89be$var$load("h3ABO"),
    $0e2c93ac2e2f89be$var$load("kC80R"),
    $0e2c93ac2e2f89be$var$load("7EorR"),
    $0e2c93ac2e2f89be$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("a7vXy", function(module, exports) {

let $75e359568cd7caf1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75e359568cd7caf1$var$load("8k9aB"),
    $75e359568cd7caf1$var$load("fLwVm"),
    $75e359568cd7caf1$var$load("2YffH"),
    $75e359568cd7caf1$var$load("h6MOP"),
    $75e359568cd7caf1$var$load("gaF3h"),
    $75e359568cd7caf1$var$load("eXKRO"),
    $75e359568cd7caf1$var$load("eBRUf"),
    $75e359568cd7caf1$var$load("5yluq"),
    $75e359568cd7caf1$var$load("2tcSk"),
    $75e359568cd7caf1$var$load("hUmZG"),
    $75e359568cd7caf1$var$load("h4Nf7"),
    $75e359568cd7caf1$var$load("8YSo7"),
    $75e359568cd7caf1$var$load("dl2qY"),
    $75e359568cd7caf1$var$load("kL5FA"),
    $75e359568cd7caf1$var$load("cHb2G"),
    $75e359568cd7caf1$var$load("g4qer"),
    $75e359568cd7caf1$var$load("3GuOt"),
    $75e359568cd7caf1$var$load("jbM5v"),
    $75e359568cd7caf1$var$load("6SWFK"),
    $75e359568cd7caf1$var$load("5zapo"),
    $75e359568cd7caf1$var$load("3MYQs"),
    $75e359568cd7caf1$var$load("6wr18"),
    $75e359568cd7caf1$var$load("9atVd"),
    $75e359568cd7caf1$var$load("53AGa"),
    $75e359568cd7caf1$var$load("8bhm4"),
    $75e359568cd7caf1$var$load("gBV5J"),
    $75e359568cd7caf1$var$load("djjX5"),
    $75e359568cd7caf1$var$load("cX4Bp"),
    $75e359568cd7caf1$var$load("dawn8"),
    $75e359568cd7caf1$var$load("ffEVr"),
    $75e359568cd7caf1$var$load("aQh37"),
    $75e359568cd7caf1$var$load("bJVDE"),
    $75e359568cd7caf1$var$load("4XdkL"),
    $75e359568cd7caf1$var$load("4eock"),
    $75e359568cd7caf1$var$load("1bbSu"),
    $75e359568cd7caf1$var$load("kuFG2"),
    $75e359568cd7caf1$var$load("b9CA3"),
    $75e359568cd7caf1$var$load("Wowvf"),
    $75e359568cd7caf1$var$load("1F7LX"),
    $75e359568cd7caf1$var$load("jZLnv"),
    $75e359568cd7caf1$var$load("6edij"),
    $75e359568cd7caf1$var$load("3QXpo"),
    $75e359568cd7caf1$var$load("hhss7"),
    $75e359568cd7caf1$var$load("fuks3"),
    $75e359568cd7caf1$var$load("lnKog"),
    $75e359568cd7caf1$var$load("h3ABO"),
    $75e359568cd7caf1$var$load("kC80R"),
    $75e359568cd7caf1$var$load("7EorR"),
    $75e359568cd7caf1$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== resolvedAttachmentId || $[6] !== returnBlockedExtensions || $[7] !== skipQuery || $[8] !== spaceContextOnly || $[9] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = resolvedAttachmentId;
        $[6] = returnBlockedExtensions;
        $[7] = skipQuery;
        $[8] = spaceContextOnly;
        $[9] = spaceKey;
        $[10] = t3;
    } else t3 = $[10];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[11] !== extsError || $[12] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[11] = extsError;
        $[12] = spaceError;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[15] !== extsData || $[16] !== extsError || $[17] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[15] = extsData;
        $[16] = extsError;
        $[17] = extsLoading;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("earLp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

var $a91836006a246f35$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_TITLE_DATA_CLASSIFICATION_POPUP"] = "editorTitleDataClassificationPopup";
    ActionSubjectId["CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP"] = "contentTypeTitleDataClassificationPopup";
    ActionSubjectId["GENERIC_DATA_CLASSIFICATION_MODAL_POPUP"] = "genericDataClassificationModalPopup";
    return ActionSubjectId;
}({});
const $a91836006a246f35$var$getEditPopupViewedScreenEvent = ({ cloudId: cloudId, spaceId: spaceId, orgId: orgId, actionSubjectId: actionSubjectId })=>({
        type: 'sendScreenEvent',
        data: {
            name: 'dataClassificationEditPopup',
            action: 'viewed',
            actionSubject: 'popup',
            actionSubjectId: actionSubjectId,
            attributes: {
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId
            }
        }
    });
const $a91836006a246f35$export$c5f7a48280d6f361 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== cloudId || $[1] !== createAnalyticsEvent || $[2] !== orgId || $[3] !== spaceId) {
        t0 = {
            trackEditPopupViewed: (actionSubjectId)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                    cloudId: cloudId,
                    spaceId: spaceId,
                    orgId: orgId,
                    actionSubjectId: actionSubjectId
                })).fire();
            },
            trackRenderTagError: (errorMessage)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "failed",
                        actionSubject: "dataClassificationTagRender",
                        source: "confluence-frontend",
                        attributes: {
                            cloudId: cloudId,
                            spaceId: spaceId,
                            orgId: orgId,
                            error: errorMessage
                        }
                    }
                }).fire();
            }
        };
        $[0] = cloudId;
        $[1] = createAnalyticsEvent;
        $[2] = orgId;
        $[3] = spaceId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return {
        trackEditPopupViewed: (actionSubjectId)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId,
                actionSubjectId: actionSubjectId
            })).fire();
        },
        trackRenderTagError: (errorMessage)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'dataClassificationTagRender',
                    source: 'confluence-frontend',
                    attributes: {
                        cloudId: cloudId,
                        spaceId: spaceId,
                        orgId: orgId,
                        error: errorMessage
                    }
                }
            }).fire();
        }
    };
};
module.exports["ActionSubjectId"] = $a91836006a246f35$export$cb7d54f314e067cb;
module.exports["useTrackClassificationAnalytics"] = $a91836006a246f35$export$c5f7a48280d6f361;

});

parcelRegister("93WhG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $81f08aaba4f97dd2$export$39a13631616da233 = (0, $aXWIB.defineMessages)({
    classifyContent: {
        id: "data-classification.shared-messages.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    fetchErrorTextPrimary: {
        id: "data-classification.shared-messages.fetch-error.primary",
        defaultMessage: "Unable to load classification. Try again."
    },
    fetchErrorTextSecondary: {
        id: "data-classification.shared-messages.fetch-error.secondary",
        defaultMessage: "Try reloading now."
    },
    saveErrorTextPrimary: {
        id: "data-classification.shared-messages.save-error.primary",
        defaultMessage: "Update to classification failed to save"
    },
    saveErrorTextSecondary: {
        id: "data-classification.shared-messages.save-error.secondary",
        defaultMessage: "Please try again."
    }
});
module.exports["sharedMessages"] = $81f08aaba4f97dd2$export$39a13631616da233;

});

parcelRegister("70LTe", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");

const $da99c994e33d3600$export$6654a9a4dc3a2802 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return $da99c994e33d3600$var$_temp;
} : ()=>{
    return (0, $42omo.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
function $da99c994e33d3600$var$_temp(payload, type) {
    window.parent.postMessage({
        type: type,
        payload: payload
    }, "*");
}
module.exports["useEmbeddedConfluenceEventMarkers"] = $da99c994e33d3600$export$6654a9a4dc3a2802;

});

parcelRegister("bPoXA", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("1RN2b")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $7VdCF = parcelRequire("7VdCF");


var $1RN2b = parcelRequire("1RN2b");


const $593a9a70400e9fe4$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VbFx8",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("iIEQu"))).CopyLink;
    },
    loading: (0, $7VdCF.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $593a9a70400e9fe4$export$9d30156e45c09e81;

});

parcelRegister("7VdCF", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");

const $e679cdda51869592$var$i18n = (0, $aXWIB.defineMessages)({
    copyLinkLabel: {
        id: "share-and-restrict-dialog.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $e679cdda51869592$export$1f3200a5b8d4d8e1 = ()=>{
    const $ = (0, $frIzR.c)(4);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($e679cdda51869592$var$i18n.copyLinkLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "copy-link-button-placeholder",
            "data-test-id": "copy-link-button-placeholder",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: t0,
                spacing: "spacious"
            }),
            isDisabled: true
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["CopyLinkButtonPlaceholder"] = $e679cdda51869592$export$1f3200a5b8d4d8e1;

});

parcelRegister("iIEQu", function(module, exports) {

let $da0c051fa845010e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da0c051fa845010e$var$load("esywo"),
    $da0c051fa845010e$var$load("9RX5o")
]).then(()=>parcelRequire('eB05M'));

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("6goKc"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $9VJDA = parcelRequire("9VJDA");

const $565f8db62106cdff$var$i18n = (0, $aXWIB.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("6goKc", function(module, exports) {

let $48f76e5dd77758eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $48f76e5dd77758eb$var$load("eaPVf"),
    $48f76e5dd77758eb$var$load("6wr18"),
    $48f76e5dd77758eb$var$load("ffEVr"),
    $48f76e5dd77758eb$var$load("fM5g3"),
    $48f76e5dd77758eb$var$load("esywo"),
    $48f76e5dd77758eb$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("gqypm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip, fetchPolicy: fetchPolicy })=>{
    const legacyResult = (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        fetchPolicy: fetchPolicy
    });
    if (!(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return {
        data: legacyResult.data,
        loading: legacyResult.loading,
        error: legacyResult.error ?? undefined
    };
    // Exp on: adapt traits result into legacy data/loading/error shape
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("kxhju", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "@confluence/web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("lOI2p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onClose: onClose, popupRef: popupRef, triggerRef: triggerRef } = t0;
    let t1;
    let t2;
    if ($[0] !== onClose || $[1] !== popupRef || $[2] !== triggerRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const keyDownEvent = (t3)=>{
                const { key: key } = t3;
                if (key === "Escape" || key === "Esc") onClose();
            };
            const clickEvent = (event)=>{
                if (!document.body.contains(event.target)) return;
                if (popupRef && popupRef.contains(event.target)) return;
                if (triggerRef && triggerRef.contains(event.target)) return;
                if (event.target.closest(".atlaskit-portal-container [role=dialog]")) return;
                onClose();
            };
            window.addEventListener("click", clickEvent);
            window.addEventListener("keydown", keyDownEvent);
            return ()=>{
                window.removeEventListener("click", clickEvent);
                window.removeEventListener("keydown", keyDownEvent);
            };
        };
        t2 = [
            popupRef,
            triggerRef,
            onClose
        ];
        $[0] = onClose;
        $[1] = popupRef;
        $[2] = triggerRef;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("gektR", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const handleError = (0, $42omo.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "@confluence/content-topper"
    });
    const isTitleAlignmentLoading = networkStatus === (0, $5T18X.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $5T18X.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $42omo.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $42omo.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                __callerPackage__: "@confluence/content-topper"
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: cacheData,
                                __callerPackage__: "@confluence/content-topper"
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});

parcelRegister("80koo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $42omo.useState)({
        loaded: false,
        modules: []
    });
    (0, $42omo.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};
module.exports["RequireLegacyWRM"] = $c65634971abef8c1$export$c2019f6d43c6c1ce;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "@confluence/super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});


//# sourceMappingURL=EditorByLineArea.33e7f6a2.js.map
